app.component("procedureSearchBox", {
	templateUrl: "app/src/js/components/operationNote/eyeSection/procedureSearchBox.html",
	controller: "procedureSearchBoxController",
	bindings: {
		eyeTitle: "=",
        setProcedure: "&",
		label: "@",
		isRequired: "@",
		isMultiple: "@",
		isNonCataract: "=",
		procedureList: "<",
		procedure: "=",
		savedProcedures: "="
	},
});

app.controller("procedureSearchBoxController", [
	"$scope",
	"DiagnosisAPI",
	"$timeout",
	function ($scope, DiagnosisAPI, $timeout) {
		this.$onInit = function () {
			$scope.noResults = false;
			$scope.DiagnosisAPI = DiagnosisAPI;
			$scope.formData = {
				diagnosis: "",
				search_term: "",
				diagnosis_object: null,
				diagnosis_type: "ocular"
			};
			$scope.procedureList = [];
			$scope.warn = false;

			// Initialize existing data
			if ($scope.$ctrl.procedure && !$scope.$ctrl.isMultiple) {
				$scope.formData.diagnosis_object = $scope.$ctrl.procedure;
				if ($scope.formData.diagnosis_object.pt) {
					$scope.formData.diagnosis = $scope.formData.diagnosis_object.pt.term;
				}
			}
		};

		$scope.loading = false;

		$scope.$watch("$ctrl.procedureList", function (newValue, oldValue) {
			// Follow the bound list even when it is emptied, or removed procedures stay listed.
			if (angular.isArray(newValue)) {
				$scope.procedureList = newValue;
			}
		}, true);

		$scope.$watch(
			"formData.diagnosis",
			function (newValue, oldValue) {
				if (newValue === '') {
					$scope.noResults = false;
				}
				// If user types over a selected item, clear the object
				if ($scope.formData.diagnosis_object &&
					$scope.formData.diagnosis_object.pt &&
					$scope.formData.diagnosis_object.pt.term !== newValue) {

					$scope.formData.diagnosis_object = null;
					$scope.$ctrl.setProcedure({
						form: {
							diagnosis: $scope.formData.search_term,
							operative_eye: $scope.formData.operative_eye,
							diagnosis_object: null
						}
					});
				}
			},
			true
		);

		$scope.fetch = function (value) {
			$scope.loading = true;
			return new Promise((resolve, reject) => {
				searchDiagnosis(value, resolve, reject)
			})
		};

		function searchDiagnosis(terms, resolve, reject) {
			$scope.result = [];
			$scope.noResults = false;
			const isOcular = $scope.formData.diagnosis_type === 'ocular';
			$scope.DiagnosisAPI.searchDiagnosis(terms, isOcular, $scope.$ctrl.isNonCataract)
				.then(
					function (resp) {
						if (resp.data) {
							// Process results to show tags in dropdown
							$scope.result = processResult(resp.data);
							$scope.formData.search_term = terms;
							if (resp.data.length === 0) {
								$scope.formData.diagnosis = '';
							}
							resolve($scope.result)
						}
					},
					function (err) {
						console.error("procedure search failed", err && err.status);
						$scope.noResults = true;
						$scope.result = [];
						$scope.formData.diagnosis = '';
						reject(err)
					}
				).then(function () {
					$scope.loading = false;
				})
		}

		// Add the tag for the Dropdown UI
		const processResult = (data) => {
			return data.map((t) => {
				// Safety check: ensure PT and FSN exist
				if (t.pt && t.fsn && t.fsn.term) {
					// Extract tag e.g., "(procedure)"
					const match = t.fsn.term.match(/\s*\([^)]+\)$/);
					const tag = match ? match[0] : "";

					// Append tag to PT so the user sees "Iridectomy (procedure)"
					// Only append if it's not already there
					if (!t.pt.term.includes(tag)) {
						t.pt.term = t.pt.term + tag;
					}
				}
				return t;
			});
		};

		// Strip the tag and FSN for the Model
		function getCleanItem(item) {
			const clean = angular.copy(item);

			// Remove the tag we added in processResult
			if (clean.pt && clean.pt.term) {
				clean.pt.term = clean.pt.term.replace(/\s*\([^)]+\)$/, "").trim();
			}

			// Strictly remove FSN object as this can throw 403 XSS risk detected BE API errors.
			if (clean.fsn) {
				delete clean.fsn;
			}
			return clean;
		}

		$scope.addProcedure = function () {
			if ($scope.$ctrl.isMultiple && $scope.pendingItem) {
				// Clean before pushing to list
				const cleanPending = getCleanItem($scope.pendingItem);
				$scope.procedureList.push(cleanPending);
				$scope.$ctrl.setProcedure({ form: $scope.procedureList });
				$scope.pendingItem = null;
				$scope.formData.diagnosis = null;
				$scope.warn = false;
			}
		}

		$scope.removeProcedure = function (index) {
			$scope.procedureList.splice(index, 1);
			$scope.$ctrl.setProcedure({ form: $scope.procedureList });
		}

		$scope.diagnosisOnSelect = function (item) {
			// Clean before setting to local model and emitting
			const cleanItem = getCleanItem(item);

			if ($scope.$ctrl.isMultiple) {
				$scope.pendingItem = cleanItem;
				$scope.warn = true;
				return;
			}

			$scope.formData.diagnosis_object = cleanItem;

			// Update the input box text to the clean version
			if (cleanItem.pt) {
				$scope.formData.diagnosis = cleanItem.pt.term;
			}

			$scope.$ctrl.setProcedure({
				form: {
					diagnosis: $scope.formData.search_term,
					diagnosis_object: cleanItem
				}
			});
		}

		$scope.onBlur = function () {
			$timeout(function () {
				if (!$scope.formData.diagnosis_object && !$scope.pendingItem) {
					$scope.formData.diagnosis = "";
					$scope.noResults = false;
				}
			}, 200);
		};

		$scope.$watch(
			"$ctrl.procedure",
			function (newValue) {
				if (newValue) {
					if (newValue.primary_procedure) {
						$scope.formData.diagnosis_object = newValue.primary_procedure;
						if ($scope.formData.diagnosis_object.pt) {
							$scope.formData.diagnosis = $scope.formData.diagnosis_object.pt.term;
						}
					}

					if (newValue.secondary_procedure_list) {
					}
				}
			},
			true,
		);
	},
]);